import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin } from "lucide-react";
import { CONTACTS, WA_DEFAULT } from "@/data/content";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="bg-xmove-night text-white" data-testid="footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-4 lg:px-8">
      <div className="md:col-span-2">
        <Logo dark />
        <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
          Noleggio a lungo termine multimarca. Selezioniamo per te le migliori offerte
          dello stock più ampio d'Italia, con un unico referente dedicato.
        </p>
        <div className="mt-4 space-y-1.5 text-sm text-white/50" data-testid="footer-locations">
          <p className="flex items-center gap-2">
            <MapPin size={15} className="shrink-0 text-xmove-orange" /> Genzano di Roma (RM)
          </p>
          <p className="flex items-center gap-2">
            <MapPin size={15} className="shrink-0 text-xmove-orange" /> Torino
          </p>
          <p className="flex items-center gap-2">
            <MapPin size={15} className="shrink-0 text-xmove-orange" /> Reggio nell'Emilia
          </p>
          <p className="pl-[23px] text-white/70">Operiamo in tutta Italia, con consegne gratuite.</p>
        </div>
      </div>
      <div>
        <h4 className="font-display text-sm font-semibold uppercase tracking-widest text-white/40">Navigazione</h4>
        <ul className="mt-5 space-y-3 text-sm">
          <li><Link to="/" data-testid="footer-link-home" className="text-white/70 transition-colors hover:text-xmove-orange">Home</Link></li>
          <li><Link to="/offerte/" data-testid="footer-link-offerte" className="text-white/70 transition-colors hover:text-xmove-orange">Tutte le offerte</Link></li>
          <li><Link to="/noleggio-lungo-termine-usato/" data-testid="footer-link-nlt-usato" className="text-white/70 transition-colors hover:text-xmove-orange">Noleggio lungo termine usato</Link></li>
          <li><Link to="/usato/" data-testid="footer-link-usato" className="text-white/70 transition-colors hover:text-xmove-orange">Auto usate a stock</Link></li>
          <li><Link to="/noleggio-lungo-termine-partita-iva/" data-testid="footer-link-piva" className="text-white/70 transition-colors hover:text-xmove-orange">Noleggio Partita IVA</Link></li>
          <li><Link to="/noleggio-lungo-termine-aziende/" data-testid="footer-link-aziende" className="text-white/70 transition-colors hover:text-xmove-orange">Noleggio Aziende</Link></li>
          <li><Link to="/noleggio-lungo-termine-privati/" data-testid="footer-link-privati" className="text-white/70 transition-colors hover:text-xmove-orange">Noleggio Privati</Link></li>
          <li><Link to="/guide/" data-testid="footer-link-guide" className="text-white/70 transition-colors hover:text-xmove-orange">Guide e blog</Link></li>
          <li><Link to="/chi-siamo/" data-testid="footer-link-chi-siamo" className="text-white/70 transition-colors hover:text-xmove-orange">Chi Siamo</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-display text-sm font-semibold uppercase tracking-widest text-white/40">Contatti</h4>
        <ul className="mt-5 space-y-3 text-sm">
          <li>
            <a href="tel:+393751399435" data-testid="footer-phone-link" className="flex items-center gap-2 text-white/70 transition-colors hover:text-xmove-orange">
              <Phone size={15} className="text-xmove-orange" /> +39 375 139 9435
            </a>
          </li>
          <li>
            <a href={WA_DEFAULT} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-2 text-white/70 transition-colors hover:text-xmove-orange">
              <MessageCircle size={15} className="text-xmove-orange" /> {CONTACTS.whatsappDisplay}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 text-xs text-white/40 md:flex-row lg:px-8">
        <span data-testid="footer-legal">© 2025 XMOVE SRL — P.IVA 18201761006</span>
        <span className="flex gap-5">
          <span data-testid="footer-privacy">Privacy Policy (Iubenda)</span>
          <span data-testid="footer-cookie">Cookie Policy</span>
          <Link to="/assistente-contenuti/" data-testid="footer-area-interna" className="text-white/30 transition-colors hover:text-xmove-orange">Area interna</Link>
        </span>
      </div>
    </div>
  </footer>
);
